
import { EAuthMethod } from '@/helpers/enums'
import { validateEnum } from '@/helpers/index'

export default {
  name: 'LoginSavedMethod',
  props: {
    method: {
      validator(value) {
        return validateEnum(value, EAuthMethod)
      },
      default: EAuthMethod.EMAIL
    }
  },
  computed: {
    isNotSmallScreen() {
      return !this.$vuetify.breakpoint.smAndDown
    },

    methodElement() {
      return `<span class="font-weight-bold">${this.$t(this.methodVerbiage)}</span>`
    },
    methodVerbiage() {
      return `talent.login.method.${this.method}`
    },
    cardVerbiages() {
      return {
        title: this.$t('talent.login.welcome.back'),
        subtitle: this.$t('talent.login.saved.login.method', { loginMethod: this.methodElement })
      }
    }
  },
  methods: {}
}
